import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store';
import fetchAPI from "../../../common/fetchAPI";
import { RoleStateClass } from "./interfaces/roleStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: RoleStateClass = {
    isLoading: true,
    status: 'idle',
    roleList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'Role',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        role: RoleStateClass;
    },
}

export const getAccountRolesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'role/v2/getAccountRoles',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/roles', 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const getAccountRoleByAccountRoleIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'role/v2/getAccountRoleByAccountRoleId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/roles/' + arg, 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const addAccountRoleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'role/v2/addRole',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/roles/', 'POST', arg, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountRoleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'role/v2/updateAccountRole',
        async (arg, thunkApi) => {
            const { AccountRoleId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/roles/' + AccountRoleId, 'PUT', argWithoutId, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountRoleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'role/v2/deleteAccountRole',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/roles/' + arg, 'DELETE', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountRoleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "role/v2/DeleteSelectedAccountRole",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/roles/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )


export const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.roleList.findIndex((item) => item.AccountRoleId == action.payload);
            const newArray = [...state.roleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.roleList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.roleList.findIndex((item) => item.AccountRoleId == action.payload);
            const newArray = [...state.roleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.roleList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.roleList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.roleList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.roleList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.roleList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.roleList;
            state.roleList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountRolesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountRolesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.roleList = [];
                } else {
                    state.roleList = payload.Data;
                    state.roleList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountRolesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getAccountRoleByAccountRoleIdAsync.pending, (state) => {
                state.status = 'loading';
                 state.isLoading = true;

            })
            .addCase(getAccountRoleByAccountRoleIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
                state.isLoading = false;


            })
            .addCase(getAccountRoleByAccountRoleIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountRoleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountRoleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountRoleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(updateAccountRoleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountRoleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountRoleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAccountRoleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountRoleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountRoleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(DeleteSelectedAccountRoleAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountRoleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountRoleAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading =false;

            })

    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting, updatePagination
} = roleSlice.actions
export const RoleState = (state: RootState) => state.role
export default roleSlice.reducer
